



import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Tooltip, { TooltipColor } from '@/shared/components/Tooltip.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

export enum FlatSelectorIconColor {
    Primary = 'icon-color--primary',
    Secondary = 'icon-color--secondary',
    GreyDark = 'icon-color--grey-dark',
}

export enum FlatSelectorIconTooltipTexts {
    By = 'Por ',
    SendOK = 'Anular comunicación',
    SendKO = 'Enviado por ',
    ConfOK = 'Anular comunicación',
    ConfKO = 'Recibido por ',
}

@Component({
  components: {
    Tooltip,
    Icon,
  },
})

export default class FlatSelectorIcon extends Vue {
  // PROPS
  @Prop( { default: false } ) private initialSendState!: boolean;
  @Prop( { default: false } ) private initialConfState!: boolean;
  @Prop( { default: undefined } ) private sendLastAction!: any;
  @Prop( { default: undefined } ) private confLastAction!: any;
  @Prop() private iconClass!: string;
  @Prop() private iconType!: string;
  @Prop( { default: false } ) private inOddContainer!: boolean;
  @Prop( { default: false } ) private forceMarginLeft8!: boolean;

  // DATA
  private sendState: boolean = false;
  private confState: boolean = false;
  private globalLastAction: any = false;
  private states: any = {};
  private showOptions: boolean = false;
  private showOptionsTimeout!: any;

  @Watch('sendLastAction')
  private watchSendLastAction(newVal: any, oldVal: any) {
    this.initSecondLine();
  }

  @Watch('confLastAction')
  private watchConfLastAction(newVal: any, oldVal: any) {
    this.initSecondLine();
  }

  // HOOK LIFECICLE
  private created() {
      this.sendState = this.initialSendState;
      this.confState = this.initialConfState;
      this.states = {
        send: {
          value: this.sendState,
          changed: false,
        },
        conf: {
          value: this.confState,
          changed: false,
        },
      };
      this.initSecondLine();
  }

  // COMPUTED

  get getGlobalClass() {
    if ( this.confState ) {
      return FlatSelectorIconColor.Primary;
    } else if ( this.sendState ) {
      return FlatSelectorIconColor.Secondary;
    } else {
      return FlatSelectorIconColor.GreyDark;
    }
  }

  get getTooltipGlobalText() {
    if ( this.confState ) {
      return ( FlatSelectorIconTooltipTexts as any )[ 'ConfKO' ] + this.iconType;
    } else if ( this.sendState ) {
      return ( FlatSelectorIconTooltipTexts as any )[ 'SendKO' ] + this.iconType;
    } else {
      return ( FlatSelectorIconTooltipTexts as any )[ 'By' ] + this.iconType;
    }
  }

  get getTooltipGlobalClass() {
    if ( this.confState ) {
      return TooltipColor.Primary;
    } else if ( this.sendState ) {
      return TooltipColor.Secondary;
    } else {
      return TooltipColor.Primary;
    }
  }

  get showTooltipGlobalSecondLine() {
    const sendLastActionOK = ( this.sendLastAction && this.sendLastAction.dates && this.sendLastAction.user );
    const confLastActionOK = ( this.confLastAction && this.confLastAction.dates && this.confLastAction.user );
    return ( sendLastActionOK || confLastActionOK );
  }

  get getTooltipGlobalSecondLine() {
    return {
      dates: ( this.globalLastAction ) ? this.globalLastAction.dates : '',
      user: ( this.globalLastAction ) ? this.globalLastAction.user : '',
    };
  }

  get showTooltipSendSecondLine() {
    const sendLastActionOK = ( this.sendLastAction && this.sendLastAction.dates && this.sendLastAction.user );
    return (sendLastActionOK && this.sendState && this.confState);
  }

  get getTooltipSendSecondLine() {
    return {
      dates: ( this.showTooltipSendSecondLine ) ? this.sendLastAction.dates : '',
      user: ( this.showTooltipSendSecondLine ) ? this.sendLastAction.user : '',
    };
  }

  // METHODS

  private initSecondLine() {
    const sendLastActionCopy = Object.assign( {}, this.sendLastAction );
    const confLastActionCopy = Object.assign( {}, this.confLastAction );
    this.globalLastAction = ( this.sendLastAction && this.sendLastAction.dates ) ?
      sendLastActionCopy :
      confLastActionCopy;
  }

  private handleMouseEnter() {
    this.$emit('mouseenter', true);
  }

  private tooltipText( iconOption: string ) {
    if ( iconOption === 'send' ) {
      const sentStateOkKo = ( this.sendState && !this.confState ) ? 'SendOK' : 'SendKO';
      const auxString = ( this.sendState && !this.confState ) ? '' : this.iconType;
      return ( FlatSelectorIconTooltipTexts as any )[ sentStateOkKo ] + auxString;
    } else if ( iconOption === 'conf' ) {
      const confStateOkKo = ( this.confState ) ? 'ConfOK' : 'ConfKO';
      const auxString = ( this.confState ) ? '' : this.iconType;
      return ( FlatSelectorIconTooltipTexts as any )[ confStateOkKo ] + auxString;
    }
  }

  private tooltipClass( iconOption: string ) {
    if ( iconOption === 'send' ) {
      if ( this.sendState && !this.confState ) {
        return TooltipColor.GreyDark;
      } else {
        return TooltipColor.Secondary;
      }
    } else if ( iconOption === 'conf' ) {
      if ( this.confState ) {
        return TooltipColor.GreyDark;
      } else {
        return TooltipColor.Primary;
      }
    }
  }

  private checkState( iconOption: string ) {
    if ( iconOption === 'send' ) {
      return this.sendState && !this.confState;
    } else if ( iconOption === 'conf' ) {
      return this.confState;
    }
  }

  private setShowOptions( value: boolean ) {
    this.showOptionsTimeout = setTimeout(
      () => { this.showOptions = value; },
      500,
    );
  }

  private changeState( iconOption: string ) {
    let statesToEmit: any = {};
    if ( iconOption === 'send' ) {
      if (!this.confState) {
        this.sendState = !this.sendState;
      }
      this.states.send = {
        value: this.sendState,
      };
      statesToEmit = Object.assign( {}, this.states );
      statesToEmit.send.changed = true;
    } else if ( iconOption === 'conf' ) {
      this.confState = !this.confState;
      this.states.conf = {
        value: this.confState,
      };
      statesToEmit = Object.assign( {}, this.states );
      statesToEmit.send.changed = true;
    }
    this.setShowOptions( false );
    this.$emit( 'input', statesToEmit );
  }

  private handleMouseleave() {
    if ( !this.showOptions && this.showOptionsTimeout ) {
      window.clearTimeout( this.showOptionsTimeout );
    }
    this.setShowOptions( false );
  }

  private handleClick( iconOption: string ) {
    this.changeState( iconOption );
  }

}
